import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import { Coordinates } from '@ocx-app/modules/stores/types';
import { TARGET_LOCATION_PARAM_KEY, TARGET_LOCATION_SEPARATOR } from '@ocx-app/hooks/useGetNavigationActions';

type StoreParams = {
  urlParamCoordinates: Coordinates;
  specificStoreUUID: string;
};

export const useGetSpecificStoreFromUrlParams = (): StoreParams | null => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlParamRawCoordinates = searchParams.get(TARGET_LOCATION_PARAM_KEY)?.split(TARGET_LOCATION_SEPARATOR) || [
      '',
      '',
      '',
    ];

    const urlParamLat = urlParamRawCoordinates[0] !== '' ? Number(urlParamRawCoordinates[0]) : undefined;
    const urlParamLng = urlParamRawCoordinates[1] !== '' ? Number(urlParamRawCoordinates[1]) : undefined;
    const specificStoreUUID = urlParamRawCoordinates[2];

    const urlParamCoordinates: Coordinates | undefined =
      urlParamLat !== undefined && urlParamLng !== undefined && !Number.isNaN(urlParamLat) && !Number.isNaN(urlParamLng)
        ? { lat: urlParamLat, lng: urlParamLng }
        : undefined;

    if (!urlParamCoordinates || !specificStoreUUID) {
      return null;
    }

    return { urlParamCoordinates, specificStoreUUID };
  }, [location.search]);
};
